// frontend/src/pages/AboutPage/AboutPage.jsx

import React from 'react';
import { useFacility } from '../../contexts/FacilityContext';
import styles from './AboutPage.module.css';
// Note: We no longer need to import pageStyles from layout.css as our own module will handle it.

const AboutPage = () => {
  const { facilityData, facilityLoading, facilityError } = useFacility();

  return (
    // This single main container will now manage the page layout
    <main className={styles.aboutPageContainer}>
      {facilityLoading ? (
        <div className={styles.loader}>Loading...</div>
      ) : facilityError ? (
        <div className={styles.error}>{facilityError}</div>
      ) : (
        <section id="about" className={styles.contentSection}>
          <h1 className={`${styles.pageTitle} page-main-title`}>About Us</h1>
          <div className={styles.introContent}>
            <p>
              Highview House is a 7000 square foot retreat center located upon 14 acres in Young Harris, Georgia. Highview House is owned and operated by an affiliate of the Church in Atlanta for the benefit of and use by surrounding churches sharing the common fellowship in the Lord’s Recovery. Highview House is more “retreat center” than “conference center” and has a capacity for up to 70 saints seated in the main meeting room and a sleeping capacity for up to 60 saints under roof.
            </p>
            <p>
              The express purpose of Highview House is to provide a healthy environment and pleasant venue for the gathering together of various groupings of saints of all ages for the blending, fellowship, mutual enjoyment, cherishing, nourishing, building-up, and growth in and among the surrounding churches.
            </p>
            <p>
              A detailed set of rules and guidelines for guests of Highview House can be found in the document “Highview House Rules and Guidelines.” These are designed to cultivate a healthy and sanctified atmosphere conducive to pursuing our Lord Jesus Christ in mutuality while in residence at Highview House.
            </p>
          </div>
          <div className={styles.documentsSection}>
            <h2 className={styles.sectionTitle}>Important Information for Visiting Guests</h2>
            <ul className={styles.documentsList}>
              <li>
                <a href="https://storage.googleapis.com/highview-house-bucket/public-documents/Highview%20House%20Rules%20and%20Guidelines.pdf" target="_blank" rel="noopener noreferrer">
                  <span className={styles.docIcon}>📄</span> Highview House Rules and Guidelines
                </a>
              </li>
              <li>
                <a href="https://storage.googleapis.com/highview-house-bucket/public-documents/Highview%20House%20Check%20In%20Procedures.pdf" target="_blank" rel="noopener noreferrer">
                  <span className={styles.docIcon}>📄</span> Highview House Check In Procedure
                </a>
              </li>
              <li>
                <a href="https://storage.googleapis.com/highview-house-bucket/public-documents/The%20Highview%20House%20What%20to%20Bring.pdf" target="_blank" rel="noopener noreferrer">
                  <span className={styles.docIcon}>📄</span> Highview House — What to Bring
                </a>
              </li>
            </ul>
          </div>

          <div className={styles.locationInfo}>
            <h3>Our Location</h3>
            <div className={styles.mapContainer}>
              <iframe
                width="100%"
                height="450"
                style={{ border: 0 }}
                loading="lazy"
                allowFullScreen
                title="About page location map"
                src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyDNlc0KsbVBFub3bSXHvXX_5iYRMsvZCz0&q=2375+Highview+Road,Young+Harris,Georgia`}>
              </iframe>
            </div>
          </div>
        </section>
      )}
    </main>
  );
};

export default AboutPage;